import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyEvaluationNew, HttpResponse } from "@/types";

export const candidacyEvaluationNewQueryKey = (
  companyId: string | undefined,
  jobId: string | undefined,
  candidacyId: string,
) => ["candidacy-evaluation-new", companyId, jobId, candidacyId] as const;

export const useGetCandidacyEvaluationNew = ({
  candidacyId,
}: {
  candidacyId: string;
}) => {
  const companyId = useCurrentCompanyId();
  const jobId = useCurrentJobId();

  return useQuery({
    queryKey: candidacyEvaluationNewQueryKey(companyId, jobId, candidacyId),
    queryFn: async () => {
      const path = `companies/${companyId}/jobs/${jobId}/candidacies/${candidacyId}/evaluation-new`;
      const response = await guacHttpClient.get<
        CandidacyEvaluationNew | null,
        HttpResponse<CandidacyEvaluationNew | null>
      >(path);

      return response.data;
    },
    enabled: !!candidacyId,
  });
};
